module.exports = __webpack_public_path__ + "img/ssl-30days.8f7961bb.jpg";